module.exports = __webpack_public_path__ + "img/5-full-md.d76ac29a.jpg";